module.exports = __webpack_public_path__ + "static/media/title.d74959df.png";